import script from "./ds-bottom-slot-action-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ds-bottom-slot-action-bar.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__